import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    totalCount: 0,
    totalPages: 0,
    page: 0,
    limit: 10,
    filters: {
        name: "",
        type: "", // paid, barter etc
    },
    sort_key: "id",
    sort_type: "desc",
    loading: false,
    stats: {
        total: 0,
        active: 0,
        completed: 0,
        expired: 0
    }
};

export const campaignByInfluencerSlice = createSlice({
    name: "campaignByInfluencerSlice",
    initialState,
    reducers: {
        updateDetail: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetDetail: () => {
            return initialState;
        },
    },
});

export const { updateDetail, resetDetail } = campaignByInfluencerSlice.actions;

export default campaignByInfluencerSlice.reducer;
